<template>
  <form class="form-horizontal">
    <wizard-form-row>
      <template v-slot:label>
        Set your
        <span class="text-underline" v-popover.hover="tooltips.lifeExpectancy">
          life expectancy
        </span>
      </template>
      <select class="form-control input-sm" :value="formData.lifeExpectancy"
              @change="setFormData({ lifeExpectancy: $event.target.value })">
        <option value="">- select -</option>
        <option v-for="value in lifeExpectancyOptions" :value="value" :key="value">{{ value }}</option>
      </select>
    </wizard-form-row>
    <wizard-form-row>
      <template v-slot:label>
        Set your TSP
        <span class="text-underline" v-popover.hover="tooltips.withdrawalAge">
          withdrawal age
        </span>
      </template>
      <select class="form-control input-sm" :value="formData.withdrawalAgeYears"
              @change="setFormData({ withdrawalAgeYears: $event.target.value })"
              :disabled="withdrawalAgeYears.length === 0">
        <option v-for="value in withdrawalAgeYears" :value="value" :key="value">{{ value }}</option>
      </select>
      year(s)
      <select class="form-control input-sm" :value="formData.withdrawalAgeMonths"
              @change="setFormData({ withdrawalAgeMonths: $event.target.value })"
              :disabled="withdrawalAgeMonths.length === 0">
        <option v-for="value in withdrawalAgeMonths" :value="value" :key="value">{{ value }}</option>
      </select>
      month(s)
    </wizard-form-row>
    <wizard-form-row :hasError="contributionRateHasError">
      <template v-slot:label>
        Set your TSP
        <span class="text-underline" v-popover.hover="tooltips.contributionRate">
          contribution rate
        </span>
      </template>
      <div class="input-group input-group-sm">
        <input type="number" class="form-control" :value="formData.contributionRate"
               :min="config.contributionRateMin" :max="config.contributionRateMax"
               @input="setFormData({ contributionRate: Number(Number($event.target.value).toFixed(0)) })" />
        <div class="input-group-addon">%</div>
      </div>
    </wizard-form-row>
    <wizard-form-row :hasError="growthRateHasError">
      <template v-slot:label>
        Set your TSP
        <span class="text-underline" v-popover.hover="tooltips.rateOfReturn">
          rate of return
        </span>
      </template>
      <div class="input-group input-group-sm">
        <input type="number" class="form-control" :value="formData.growthRateDisplay"
               :min="config.growthRateMin" :max="config.growthRateMax"
               @keyup="formatRate( $event, 'growthRate', $event.target.value )" />
        <div class="input-group-addon">%</div>
      </div>
    </wizard-form-row>
    <wizard-form-row :hasError="withdrawalGrowthRateHasError">
      <template v-slot:label>
        Set your TSP
        <span class="text-underline" v-popover.hover="tooltips.withdrawRate">
          rate of return after you begin to withdrawal
        </span>
      </template>
      <div class="input-group input-group-sm">
        <input type="number" class="form-control" :value="formData.withdrawalGrowthRateDisplay"
               :min="config.growthRateMin" :max="config.growthRateMax"
               @keyup="formatRate( $event, 'withdrawalGrowthRate', $event.target.value )" />
        <div class="input-group-addon">%</div>
      </div>
    </wizard-form-row>
    <wizard-form-row v-if="showFor('ac2rc', 'rc2ac', 'rc2rc')">
      <template v-slot:label>
        Set your non-regular retirement pay age
      </template>
      <select class="form-control input-sm" :value="formData.retirementAgeYears"
              @change="setFormData({ retirementAgeYears: $event.target.value })"
              :disabled="retirementAgeYears.length === 0">
        <option v-for="value in retirementAgeYears" :value="value" :key="value">{{ value }}</option>
      </select>
      year(s)
      <select class="form-control input-sm" :value="formData.retirementAgeMonths"
              @change="setFormData({ retirementAgeMonths: $event.target.value })"
              :disabled="typeof retirementAgeMonths === 'undefined' || retirementAgeMonths.length === 0">
        <option v-for="value in retirementAgeMonths" :value="value" :key="value">{{ value }}</option>
      </select>
      month(s)
    </wizard-form-row>
    <wizard-form-row :hasError="tspServiceMemberContributionHasError">
      <template v-slot:label>
        Set your TSP
        <span class="text-underline" v-popover.hover="tooltips.balanceServiceMember">
          account balance
        </span>
        from Service Member contributions
      </template>
      <div class="input-group input-group-sm">
        <div class="input-group-addon">$</div>
        <input type="number" class="form-control" :value="formData.tspServiceMemberContribution"
               :min="config.tspServiceMemberContributionMin" :max="config.tspServiceMemberContributionMax"
               @input="setFormData({ tspServiceMemberContribution: Number(Number($event.target.value).toFixed(0)) })" />
      </div>
    </wizard-form-row>
  </form>
</template>

<script>
  import RetirementInformationFormMixin from '@/js/mixins/calculator/retirement-information-form-mixin';

  export default {
    mixins: [RetirementInformationFormMixin],
  };
</script>
